import React from "react";
import PatientReportDesigner from "./PatientReportDesigner";

function PatientReportPrintTab() {
  return <PatientReportDesigner />;
}

export default PatientReportPrintTab;
